/** @prettier */

import React from 'react';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {router} from './routes/PrivateRoute';
import './language/config'; //i18

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

createRoot(container).render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  //</React.StrictMode>
);
